import { isAdminGroup } from '../NewProjectFlow/accessGroupCatalog';

export function parseGroupLabel(group) {
    const raw = String(group || '');
    const invited = raw.startsWith('Invited ');
    const rest = invited ? raw.slice('Invited '.length) : raw;
    const splitAt = rest.indexOf(': ');
    if (splitAt === -1) return { invited, id: '', name: rest };
    return { invited, id: rest.slice(0, splitAt), name: rest.slice(splitAt + 2) };
}

export function nameFromEmail(email) {
    const local = String(email || '').split('@')[0] || '';
    const words = local.replace(/[._+-]+/g, ' ').trim();
    if (!words) return String(email || '');
    return words.replace(/\b\w/g, char => char.toUpperCase());
}

export function buildPeople(projectUsersAll) {
    const byEmail = new Map();
    (projectUsersAll || []).forEach(row => {
        const rawEmail = row?.value?.email || '';
        const emailKey = rawEmail.trim().toLowerCase();
        if (!emailKey) return;
        const parsed = parseGroupLabel(row.group);
        const entry = byEmail.get(emailKey) || {
            email: rawEmail,
            fullName: '',
            userId: null,
            memberships: [],
            invites: [],
        };
        if (row?.value?.invitation) {
            entry.invites.push({
                inviteId: row.value.invite_id,
                groupId: String(parsed.id),
                groupName: parsed.name,
                expired: Boolean(row.value.expired),
            });
        } else {
            entry.memberships.push({
                groupMemberId: row.value.group_member_id,
                groupId: String(parsed.id),
                groupName: parsed.name,
                userId: row.value.user_id,
            });
            if (row.value.full_name) entry.fullName = row.value.full_name;
            if (row.value.user_id) entry.userId = row.value.user_id;
        }
        byEmail.set(emailKey, entry);
    });

    return Array.from(byEmail.values()).map(entry => {
        const adminMembership = entry.memberships.find(item => isAdminGroup({ name: item.groupName }));
        const adminInvite = entry.invites.find(item => isAdminGroup({ name: item.groupName }));
        const accessMembership = entry.memberships.find(item => !isAdminGroup({ name: item.groupName }));
        const accessInvite = entry.invites.find(item => !isAdminGroup({ name: item.groupName }));
        const isAdmin = Boolean(adminMembership || adminInvite);
        const pendingInvites = entry.invites;
        const status = pendingInvites.length > 0 && !accessMembership ? 'pending' : 'active';
        const accessGroupName = accessMembership?.groupName || accessInvite?.groupName || (isAdmin ? 'Project Administrator' : '');
        const accessGroupId = accessMembership?.groupId || accessInvite?.groupId || '';
        return {
            email: entry.email,
            fullName: entry.fullName || nameFromEmail(entry.email),
            userId: entry.userId,
            isAdmin,
            accessGroupName,
            accessGroupId,
            status,
            expired: pendingInvites.some(item => item.expired),
            inviteIds: pendingInvites.map(item => item.inviteId).filter(Boolean),
            groupMemberId: accessMembership?.groupMemberId || adminMembership?.groupMemberId || null,
        };
    });
}
